import moment from 'moment-timezone'

export const checkOffHours = (timeslot: string, timezone: string) => {
	const momentTime = moment(timeslot).tz(timezone)

	// Get the hour and minute in 24-hour format
	const hour = momentTime.hour()
	const minute = momentTime.minute()

	// Convert to minutes for easier comparison
	const timeInMinutes = hour * 60 + minute

	// Off hours: >= 6:00 PM (18:00 = 1080 minutes) or <= 8:00 AM (08:00 = 480 minutes)
	const isOffHour = timeInMinutes >= 1080 || timeInMinutes <= 480

	return isOffHour
}

export const checkIsEarlyOffHours = (timeslot: string, timezone: string) => {
	const momentTime = moment(timeslot).tz(timezone)

	const hour = momentTime.hour()
	const minute = momentTime.minute()

	// Early bird: 3:01 AM to 8:00 AM
	// Convert to minutes for easier comparison
	const timeInMinutes = hour * 60 + minute

	// 3:01 AM = 3 * 60 + 1 = 181 minutes
	// 8:00 AM = 8 * 60 + 0 = 480 minutes
	return timeInMinutes >= 181 && timeInMinutes <= 480
}
